import React from "react";
import { Box } from "@material-ui/core";
import { getPriceString } from "halifax";
import type { FareDetails } from "redmond";
import { useAdjustedChfarFareById } from "../../hooks/useAdjustedChfarFareById";

interface ChfarExerciseCTAContentProps {
  fare?: FareDetails;
}
export const ChfarExerciseCTAContent: React.FC<
  ChfarExerciseCTAContentProps
> = ({ fare }) => {
  const { data: adjustedChfarFare } = useAdjustedChfarFareById(fare?.id ?? "");

  const price = adjustedChfarFare?.amount?.fiat;

  if (price == null) {
    return null;
  }

  return (
    <Box>
      Continue for +
      {getPriceString({
        price: price.value,
        currencySymbol: price.currencySymbol,
      })}
    </Box>
  );
};
